import { Component, EventEmitter, Input,  OnInit,  Output,  ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective,  NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlSettings } from '../../ControlSettings';


@Component({
  selector: 'masked-text-input-ctrl',
  templateUrl: './masked-text-input.component.html',
  styleUrls: ['./masked-text-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MaskedTextInputComponent,
    multi: true
  }]
})
export class MaskedTextInputComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer) {
  
  }

  ngOnInit(): void {
    Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {uppercase:false, fxFill:false,format:'', readonly: false};

  @Output() valueChangeEvent = new EventEmitter<string>();
  @Output() blurEvent = new EventEmitter<string>();

  onChange(value: string) {
    if (this.settings.uppercase) {
      value = value.toUpperCase();
    }
    this.control.setValue(value);
    this.valueChangeEvent.emit(value);
  }

  onBlur(){
    this.blurEvent.emit(this.control.value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
